import { computed } from 'vue';
import { InitialPublicOfferItem } from '@libs/api-reference';

import { BETWEEN_START_ORDER_END_ORDER } from '../constants';

type UseBetweenStartOrderAndEndOrderType = {
  offer: InitialPublicOfferItem;
  isDoneOrder: boolean;
  isOpenOrder: boolean;
};

export default function useBetweenStartOrderAndEndOrder({
  offer,
  isOpenOrder,
  isDoneOrder,
}: UseBetweenStartOrderAndEndOrderType) {
  const flow = computed(() => {
    if (isDoneOrder) {
      return 'flow1';
    }

    if (isOpenOrder) {
      return 'flow2';
    }

    if (offer.hasPreOrder) {
      return 'flow3';
    }

    if (offer.isAutomaticSubmit) {
      return 'flow4';
    }

    return 'flow5';
  });

  return {
    time: offer.endDate,
    stylesConfig: BETWEEN_START_ORDER_END_ORDER[flow.value],
  };
}
